import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import WebsolutionsSidebar from '../../../components/WebsolutionsSidebar'
import BranddevelopmentSidebar from '../../../components/BranddevelopmentSidebar'
import DigitalmarketingSidebar from '../../../components/DigitalmarketingSidebar'

import Fill from '../../../images/Fill.svg'
import Divider from '../../../images/Divider.svg'

export const query = graphql`
  query corporate {
    cibanner: imageSharp(id: {regex: "/images/Thor.jpg/"}) {
      sizes(quality: 75, maxWidth: 1000, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
}
`

const CorporateIdentities = ({data:{cibanner}}) => (
  <section>
    <article className='container'>
    <div className='full-Width' style={{alignItems:'flex-start'}}>
      <div className='half-Width-75 paddingRight mobBottommargin'>
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Corporate Identities</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
          <p className='smallerHone'><span className='gradient'>Case studies such as these inspire and motivate us.</span></p>
          <p>See how businesses similar to yours are growing with Digital Marketing.</p>
          <div style={{backgroundImage:`url("${cibanner.sizes.src}"), url("${cibanner.sizes.tracedSVG}")`, backgroundPosition:'center', backgroundSize:'cover', minHeight:'50vh', marginBottom:'1.45rem'}}>
          </div>
          <p>Visual Identity is the primary means of brand recognition and the first element that distinguishes one brand from another
          (logo, business card, letterheads, company profile, and website).</p>
          <p style={{marginBottom:'0'}}>As a digital marketing company will firstly have a detailed research of your industry,
          identify your state and design an outstanding company identity campaign that that will build a trust,
          which will eventually place a permanent imprint of your brand in the targeted customer’s mind.</p>
        </div>
      </div>
      <div className='half-Width-25 service-sidebar'>
        <div style={{marginBottom:'2.5rem'}}><DigitalmarketingSidebar /></div>
        <div style={{marginBottom:'2.5rem'}}><WebsolutionsSidebar /></div>
        <div><BranddevelopmentSidebar /></div>
      </div>
    </div>
    </article>
  </section>
)

export default CorporateIdentities



// WEBPACK FOOTER //
// ./src/pages/services/brand-development/corporate-identities.js